export const excludedCurrencies = ['RUB', 'HRK'];
